import cardValidator from 'card-validator';

export const required = value =>
  value && (typeof value !== 'string' || value.toLowerCase() !== 'not found')
    ? undefined
    : 'Required Field';

export const maxLength = max => value =>
  value && value.length > max
    ? `Cannot Be Longer Than ${max} Characters`
    : undefined;

export const minLength = min => value =>
  value && value.length < min
    ? `Must Be At Least ${min} Characters`
    : undefined;

export const length = length => value =>
  value && value.length !== length
    ? `Must Be ${length} Characters Long`
    : undefined;

export const number = value =>
  value && isNaN(Number(value)) ? 'Must Be A Number' : undefined;

export const email = value =>
  value &&
  !/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(
    value
  )
    ? 'Invalid Email Address'
    : undefined;

export const password = value => {
  const isEightChars = /^.{8,}/.test(value);
  const hasUpperCaseChar = /^.*[A-Z]+.*/.test(value);
  const hasLowerCaseChar = /^.*[a-z]+.*/.test(value);

  // Allow a falsy value here, since we cover that with the required validator
  return !value || (isEightChars && hasUpperCaseChar && hasLowerCaseChar)
    ? undefined
    : 'Passwords must be at least 8 characters, include one capital letter, and one lower case letter.';
};

export const emailMatch = (value, allValues) =>
  value !== allValues.email ? 'Email Does Not Match' : undefined;

export const passwordsMatch = (value, allValues) =>
  value !== allValues.password ? 'Passwords Do Not Match' : undefined;

export const currentPasswordRequired = (value, allValues) =>
  !allValues.currentPassword &&
  (allValues.password || allValues.passwordConfirmation)
    ? 'Current password is required'
    : undefined;

export const phoneNumber = value => {
  if (
    !/^[2-9][0-9]{2}[2-9][0-9]{6}$/.test(String(value).replace(/[^\d]/g, ''))
  ) {
    return 'Valid phone number is required';
  }
};

export const cardNumber = value => {
  const validation = cardValidator.number(value);

  return !validation.isPotentiallyValid ? 'Invalid card number' : undefined;
};

export const cvvCode = value => {
  return !(value && (value.length === 3 || value.length === 4))
    ? 'Invalid Entry'
    : undefined;
};

export const nonEmpty = value => value.trim().length > 0;

export const minLength2 = minLength(2);
export const minLength4 = minLength(4);
export const maxLength40 = maxLength(40);
export const maxLength55 = maxLength(55);
export const maxLength60 = maxLength(60);
export const maxLength80 = maxLength(80);
export const length5 = length(5);
